import OfferResaleList from "./offer-resale-list";

export default OfferResaleList;